import { LocationManagementLocationType } from "types/locationManagement/locationType";
import * as Yup from "yup";

const Apple = "apple";
const exceptions = ["iser"];

export const inventoryEditValidation = Yup.object().shape({
  serialNumber: Yup.string()
    .nullable()
    .when("manufacturer", {
      is: (manufacturer: string) => manufacturer?.toLowerCase()?.includes(Apple),
      then: (schema) =>
        schema
          .nullable()
          .test("valid-apple-serial", "cannot include 'O' (ohhh)", (serialNumber) => {
            if (serialNumber === undefined || serialNumber === null) return true;
            return !serialNumber?.toLowerCase()?.includes("o");
          })
          .test("valid-apple-serial", "cannot include 'I' (eye)", (serialNumber) => {
            if (
              serialNumber === undefined ||
              serialNumber === null ||
              exceptions.find((a) => a.toLowerCase() === serialNumber?.toLowerCase())
            )
              return true;
            return !serialNumber?.toLowerCase()?.includes("i");
          }),
    }),
});

export const WAREHOUSE_LOCATION_PREFIXES = [
  "AREA",
  "CLNG",
  "CLNQ",
  "DONA",
  "ECOM",
  "ENRL",
  "EWST",
  "INDS",
  "MBLE",
  "MISS",
  "MRCH",
  "PHTQ",
  "PLLT",
  "PNDR",
  "QUAL",
  "RCVG",
  "RECD",
  "RECO",
  "RECQ",
  "RESL",
  "RPHT",
  "RPHQ",
  "RTNQ",
  "RTNT",
  "SCND",
  "SORT",
  "SRCQ",
  "STAG",
  "TECH",
  "TECQ",
  "TSFR",
  "WHOL",
  "ZONE",
];

export const warehouseLocationValidation = (location_types: LocationManagementLocationType[] | undefined) =>
  Yup.object().shape({
    location: Yup.string()
      .required("Location is required")
      .test("Check location prefix", (value) => {
        if (!value) return false;
        return (location_types?.map(({ name }) => name) || WAREHOUSE_LOCATION_PREFIXES).includes(value.split("-")[0]);
      }),
  });
